import { render, staticRenderFns } from "./ParcelTrackingItem.vue?vue&type=template&id=3c219587&"
import script from "./ParcelTrackingItem.vue?vue&type=script&lang=js&"
export * from "./ParcelTrackingItem.vue?vue&type=script&lang=js&"
import style0 from "./ParcelTrackingItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports